module.exports = __webpack_public_path__ + "static/media/cake.ac3388f5.jpg";